<template>
  <div class="thumbnail-wrap">
    <div
      class="selected"
      v-for="(obj, i) in selected"
      :key="i"
      :style="getStyle(obj.coords)"
    >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: Array
  },
  methods: {
    getStyle(coords) {
			if (coords && coords.top && coords.bottom && coords.left && coords.right) {
				let obj = {
					top: coords.top + "%",
					bottom: (100 - coords.bottom) + "%",
					left: coords.left + "%",
					right: (100 - coords.right) + "%"
				}
				return obj;
			}
		}
  }
}
</script>

<style scoped>
.thumbnail-wrap {
  position: relative;
  background-color: white;
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.selected {
  position: absolute;
  background: rgba(0, 187, 255, 0.5);
  border-radius: 5px;
}
</style>